import { Tab } from "@headlessui/react";
import { IconType } from "react-icons";

type Props = {
  icon?: IconType;
  activeIcon?: IconType;
  label: string | React.ReactNode;
  disabled?: boolean;
  title?: string;
};

const MyTab = ({ icon: Icon, activeIcon: ActiveIcon, label, disabled, title }: Props) => {
  return (
    <Tab
      title={title}
      disabled={disabled}
      className={
        "group flex w-full items-center justify-center gap-1 border-b border-secondary bg-white px-4 py-2 text-tertiary hover:text-tertiary-hover focus:outline-none data-[selected]:border-brand-primary data-[selected]:text-brand-primary data-[disabled]:opacity-40 hover:data-[selected]:text-brand-primary-hover"
      }
    >
      {Icon && <Icon className="size-5 shrink-0 group-data-[selected]:hidden" />}
      {ActiveIcon && <ActiveIcon className="hidden size-5 shrink-0 group-data-[selected]:block" />}
      <span className={"text-sm font-medium"}>{label}</span>
    </Tab>
  );
};

export default MyTab;
